import { useContext } from 'react'

import AttachedDocument from 'tripPlanner/components/Documents/AttachedDocument'
import { TripDocumentsContext } from 'tripPlanner/contexts/TripDocumentsContext'
import type { TripItem } from 'tripPlanner/types/tripItem'
import Group from 'components/utils/Group'

function Attachments({
  item,
}: {
  item: TripItem
}) {
  const documentContext = useContext(TripDocumentsContext)

  if (item.isSuggested) {
    return null
  }

  const attachedDocuments =
    documentContext?.documentsResult?.attachedFiles[item.id] ?? []

  if (!attachedDocuments.length) {
    return null
  }

  return <Group direction="horizontal" gap={8} wrap="wrap">
    {attachedDocuments.map((document) => (
      <AttachedDocument key={document.filename} document={document} item={item} />
    ))}
  </Group>
}

export default Attachments
